import { Skeleton } from '@mui/material';

export function ProductActionsSkeleton() {
  return (
    <div className="flex flex-row justify-between w-full">
      <Skeleton variant="rectangular" width={120} height={34} sx={sx} />
      <Skeleton variant="rectangular" width={120} height={34} sx={sx} />
    </div>
  );
}

///
const sx = {
  borderRadius: '17px',
};
